import { createAction } from '@reduxjs/toolkit';

export const removePersistedStateEvent = createAction('remove persisted state event');
